<div class="row form-group">
    <div class="col s3" *ngIf="toolName">
        <strong>{{toolName}} - {{setIndex}}</strong>
    </div>
    <div class="col s2">
        <input type="text"
               [readOnly]="true"
               class="form-control"
               [(ngModel)]="liftNumber"
               placeholder="{{'generic.components.locationPicker.liftInputPlaceholder'| translate}}"/>
    </div>
    <div class="col s2">
        <input type="text"
               class="form-control"
               [readOnly]="true"
               [(ngModel)]="liftShelf"
               placeholder="{{'generic.components.locationPicker.shelfInputPlaceholder'| translate}}"/>
    </div>
    <div class="col s3">
        <input #positionInput
               [readOnly]="true"
               class="form-control"
               type="text"
               maxlength="1"
               pattern=".*[^ ].*"
               [(ngModel)]="shelfPosition"
               (input)="toUpperCase($event)"
               placeholder="{{'generic.components.locationPicker.positionInputPlaceholder'| translate}}"/>
    </div>
    <div class="col s2">
        <input type="number"
               class="form-control"
               [(ngModel)]="cart"
               placeholder="{{'generic.components.locationPicker.shelfInputPlaceholder'| translate}}"/>
    </div>
</div>
<div class="row">
    <div class="col s12">
        <app-form-error-list *ngIf="showErrors" [errorMap]="formControl.errors"></app-form-error-list>
    </div>
</div>
